import React, { useEffect, useState } from "react";
import { CertificateApprovalService } from "../Services/CertificateApprovalService";

function ApproveRejectCertificate() {
    const [data, setData] = useState(null);
    const [reason, setReason] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const encodedData = params.get("data");

        if (encodedData) {
            try {
                const base64 = decodeURIComponent(encodedData);
                const json = atob(base64);
                const parsed = JSON.parse(json);
                console.log("Parsed Data:", parsed);
                setData(parsed);
            } catch (err) {
                console.error("Invalid data", err);
            }
        }
    }, []);

    const handleSubmit = () => {
        const payload = {
            ...data,
            Reason: reason.trim(),
            IsRaRequest: false,
            IsComplete: true,
        };
        console.log("Final Payload:", payload);
        const apiresponse = CertificateApprovalService.ApproveCertificate(payload);
        toast.success(apiresponse.message || "Internal Server Error");

    };

    if (!data) return <div className="text-center mt-10">Loading...</div>;

    const isApproved = data.IsApproved;

    return (
        <div className="max-w-lg mx-auto mt-10 bg-white p-6 rounded-2xl shadow-lg">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
                Certificate Approval
            </h2>

            {/* Display Info */}
            <div className="bg-gray-50 p-5 rounded-xl mb-6">
                <p className="mb-2"><strong>RA Name:</strong> {data.RaName}</p>
                <p><strong>RA ID:</strong> {data.RaId}</p>
            </div>

            {/* Status Badge */}
            <div className={`flex items-center gap-2 px-4 py-3 rounded-xl mb-6 ${isApproved
                    ? "bg-emerald-50 border border-emerald-200 text-emerald-700"
                    : "bg-red-50 border border-red-200 text-red-700"
                }`}>
                <span>{isApproved ? "✅" : "❌"}</span>
                <span className="font-medium">
                    {isApproved ? "Approved" : "Rejected"}
                </span>
            </div>

            {/* Reason Field */}
            <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    {isApproved ? "Note (optional)" : "Reason"}
                    {!isApproved && <span className="text-red-500 ml-1">*</span>}
                </label>
                <textarea
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-y min-h-[100px]"
                    placeholder={
                        isApproved
                            ? "Add any optional note..."
                            : "Please provide a detailed reason for rejection..."
                    }
                />
            </div>

            {/* Submit Button */}
            <button
                onClick={handleSubmit}
                className={`w-full py-4 rounded-xl text-white font-semibold text-lg transition-all ${isApproved
                        ? "bg-emerald-600 hover:bg-emerald-700"
                        : "bg-red-600 hover:bg-red-700"
                    }`}
            >
                {isApproved ? "Approve Certificate" : "Reject Certificate"}
            </button>
        </div>
    );
}

export default ApproveRejectCertificate;